import { BaseImageConnectionsOperation } from './base-image-connections-operation';
import { IOperation } from './i-operation';
import { Connection } from '@3d-scene/model3d/connection';
import { LoadConnectionTextureProcessor } from '@3d-scene/processor/load-connection-texture.processor';
import { ContainerService } from '@3d-scene/model3d/container.service';
import { LabelingUtils } from '@3d-scene/model3d/util/labeling-utils';

export class UndoChangeImageConnectionsOperation extends BaseImageConnectionsOperation implements IOperation {
  private _newImageHash: string;

  constructor(
    connectionCubes: Connection[],
    loadTextureProcessor: LoadConnectionTextureProcessor,
    newImageHash: string,
    containerService: ContainerService,
    labelingUtils: LabelingUtils,
  ) {
    super(connectionCubes, loadTextureProcessor, containerService, labelingUtils);

    this._newImageHash = newImageHash;
  }

  public getQualifiedClassName(): string {
    return 'UndoChangeImageConnectionsOperation';
  }

  public getOperationDescription(): string {
    return '';
  }

  public async performRedo(): Promise<void> {
    this.restoreImages(true, this._newImageHash);
  }

  public async performUndo(): Promise<void> {
    this.restoreImages();
  }
}
